import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Sparkles } from "lucide-react";

/**
 * Generic placeholder shown while the actual module isn't implemented yet.
 * Used across all module routes for Fase 1 (skeleton navegável).
 */
export default function PlaceholderPage({ title, description, icon: Icon, phase }) {
  return (
    <div data-testid={`placeholder-page-${title.toLowerCase().replace(/\s+/g, "-")}`} className="space-y-8">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3">
        <div>
          <div className="flex items-center gap-3">
            {Icon && (
              <div className="h-10 w-10 rounded-lg bg-secondary flex items-center justify-center">
                <Icon className="h-5 w-5 text-primary" strokeWidth={2} />
              </div>
            )}
            <h1 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">
              {title}
            </h1>
          </div>
          {description && (
            <p className="mt-3 text-slate-600 max-w-2xl">{description}</p>
          )}
        </div>
        {phase && (
          <Badge variant="secondary" className="w-fit">
            Previsto para {phase}
          </Badge>
        )}
      </div>

      <Card className="border-border shadow-none rounded-lg">
        <CardContent className="p-12 flex flex-col items-center text-center">
          <div className="h-16 w-16 rounded-full bg-secondary flex items-center justify-center">
            <Sparkles className="h-7 w-7 text-primary" strokeWidth={2} />
          </div>
          <h2 className="mt-6 font-heading text-2xl font-semibold text-slate-800">
            Módulo em construção
          </h2>
          <p className="mt-3 max-w-lg text-slate-600">
            Esta tela faz parte da estrutura navegável do sistema. O CRUD completo,
            regras de negócio e integrações serão implementados nas próximas fases.
          </p>
          <p className="mt-6 text-xs uppercase tracking-widest text-muted-foreground">
            Fase 1 · Esqueleto navegável
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
